import './_article-paragraph.scss';

export default () => {};
